// Shopify integration configuration. Empty values = not connected.
// Fill storeDomain and variant IDs to enable live checkout handoff
// via Shopify cart permalinks (https://{domain}/cart/{variant}:{qty}).

export const shopifyConfig = {
  storeDomain: '',
  // One Shopify variant per official configuration (SKUs in data/pricing.ts),
  // each with its own price, weight and inventory deduction (qty × M1 PRO units).
  variantIds: {
    individual: '',
    sys1: '',
    sys2: '',
    sys4: '',
    sys6: '',
    sys8: '',
    sys12: '',
    sys24: '',
    addon: '',
  } as Record<string, string>,
  discountMethod: 'bundle-variants' as 'pending' | 'automatic' | 'functions' | 'bundle-variants',
};

// Payment methods displayed near checkout CTAs. Must match the live
// Shopify Payments setup before launch (confirmed: false until then).
export const checkoutTrust = {
  provider: 'Shopify',
  paymentMethods: ['Shop Pay', 'Apple Pay', 'Google Pay', 'Visa', 'Mastercard', 'Amex'],
  confirmed: false,
};

export const trackingConfig = {
  metaPixelId: '1240164748313404',
  gtmId: '',
  conversionsApiEndpoint: '',
};
